export type RuntimeEnvKey =
  | "REACT_APP_API_URL"
  | "REACT_APP_URL"
  | "REACT_APP_REPORT_URL"
  | "REACT_APP_CERTIFICATE_URL"
  | "REACT_APP_NAICOM_URL"
  | "REACT_APP_PAYSTACK_KEY";

declare global {
  interface Window {
    _env_?: Partial<Record<RuntimeEnvKey, string>>;
  }
}

// Cluster: Express /env.js is filled from Key Vault via CSI envFrom.
// Local: falls back to a gitignored .env (CRA injects REACT_APP_* at start).
export function getEnv(key: RuntimeEnvKey): string {
  if (typeof window !== "undefined" && window._env_?.[key]) {
    return window._env_[key] || "";
  }
  return process.env[key] || "";
}
